import React from "react";

import { Props } from "./types";
import { Zone } from "./zone";
import styles from "./styles.scss";

function Loader(_: Props) {
  return (
    <ul className={styles.zonesList}>
      <li className={styles.item}>
        <Zone />
      </li>
      <li className={styles.item}>
        <Zone />
      </li>
      <li className={styles.item}>
        <Zone />
      </li>
    </ul>
  );
}

export { Loader };
